import React from 'react';
import { clsx } from 'clsx';
import { Icon } from '@/ui/icons/Icon';
import { formatAmountWithSpacesAndSymbol } from '@/lib/amountUtils';
import styles from './InstallmentCosts.module.scss';
import { Button } from '@/ui/components';

export interface InstallmentCostsProps {
  creditAmount: number | undefined;
  totalInterest?: number | undefined;
  analysisFee: number | undefined;
  totalToRepay: number | undefined;
  className?: string;
  showEditIcons?: boolean;
  interestRate?: number;
  annualRate?: number;
  onEditCreditAmount?: () => void;
}

export const InstallmentCosts: React.FC<InstallmentCostsProps> = ({
  creditAmount,
  totalInterest,
  analysisFee,
  totalToRepay,
  className,
  showEditIcons = false,
  interestRate,
  annualRate,
  onEditCreditAmount,
}) => {
  return (
    <div className={clsx(styles.costsSection, className)}>
      <div className={styles.sectionHeader}>
        <h3 className={styles.sectionTitle}>Costuri</h3>
      </div>

      <div className={styles.costsCard}>
        {/* Requested Amount */}
        <div className={styles.costRow}>
          <div className={styles.costLeft}>
            <p className={styles.costLabel}>Suma solicitată</p>
          </div>
          <div className={styles.costRight}>
            <div className={styles.costValue}>
              <span className={styles.costText}>
                {formatAmountWithSpacesAndSymbol(creditAmount, 'lei')}
              </span>
              {showEditIcons && (
                <Button
                  trackingId="edit_credit_amount_installment_costs"
                  iconOnly
                  size="xsmall"
                  className={styles.editButton}
                  variant="outlined"
                  leftIcon={<Icon name="pen" className={styles.editIcon} />}
                  onClick={onEditCreditAmount}
                />
              )}
            </div>
          </div>
        </div>

        {/* Total Interest */}
        {totalInterest && (
          <div className={styles.costRow}>
            <div className={styles.costLeft}>
              <p className={styles.costLabel}>Dobânda totală</p>
            </div>
            <div className={styles.costRight}>
              <div className={styles.costValue}>
                <span className={styles.costText}>
                  {formatAmountWithSpacesAndSymbol(totalInterest, 'lei')}
                </span>
              </div>
            </div>
          </div>
        )}

        {/* Analysis Fee */}

        {analysisFee !== undefined && analysisFee > 0 && (
          <div className={styles.costRow}>
            <div className={styles.costLeft}>
              <p className={styles.costLabel}>Comision de analiză</p>
            </div>
            <div className={styles.costRight}>
              <div className={styles.costValue}>
                <span className={styles.costText}>
                  {formatAmountWithSpacesAndSymbol(analysisFee, 'lei')}
                </span>
              </div>
            </div>
          </div>
        )}

        {/* Divider */}
        <div className={styles.divider} />

        {/* Total to Repay */}
        <div className={styles.costRow}>
          <div className={styles.costLeft}>
            <p className={styles.costLabel}>Total spre rambursare</p>
          </div>
          <div className={styles.costRight}>
            <div className={styles.costValue}>
              <span className={styles.costText}>
                {formatAmountWithSpacesAndSymbol(totalToRepay, 'lei')}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Interest Rate Info */}
      {interestRate && annualRate && (
        <div className={styles.interestInfo}>
          <p className={styles.interestText}>
            Rata anuală a dobânzii fixe, {interestRate?.toFixed(0)}%, DAE:{' '}
            {annualRate?.toFixed(0)}%.
          </p>
        </div>
      )}
    </div>
  );
};
